import React from "react";
import { Link } from "react-router-dom";

// Trang chủ mới — thay cho Application.js (đã xoá cùng cụm Resshare
// app-builder dùng Firebase). Giờ site chỉ còn 2 sản phẩm chính.
//
// Ảnh Saola có chữ/nhân vật sát mép (chữ "Saola" ở trên, con saola ở giữa-
// trái) nên KHÔNG dùng background cover (màn rộng sẽ cắt mất chữ) và KHÔNG
// đặt khung chọn đè lên ảnh. Ảnh hiện nguyên vẹn (contain), phần thừa hai
// bên lấp bằng chính ảnh đó làm mờ; khung chọn ứng dụng nằm cột riêng bên
// phải (màn hẹp thì xuống dưới ảnh).
const BG = "/327470c9-602f-4c36-b098-38898a271184.png";

const cardStyle = {
  display: "flex",
  alignItems: "center",
  gap: 14,
  padding: "18px 20px",
  borderRadius: 14,
  textDecoration: "none",
  color: "#0f172a",
  background: "#fff",
  border: "1px solid #e2e8f0",
  boxShadow: "0 1px 3px rgba(15,23,42,0.06)",
};

const css = `
.saola-home { position: relative; overflow: hidden; background: #0f172a;
  display: flex; align-items: center; justify-content: center; gap: 32px;
  min-height: calc(100vh - 43px); padding: 24px; box-sizing: border-box; }
.saola-home__blur { position: absolute; inset: -40px; background: url(${BG}) center / cover no-repeat;
  filter: blur(28px) brightness(0.55); }
.saola-home__img { position: relative; display: block; min-width: 0; flex: 0 1 auto;
  max-width: calc(100% - 392px); max-height: calc(100vh - 43px - 48px);
  border-radius: 16px; box-shadow: 0 20px 60px rgba(0,0,0,0.45); }
.saola-home__side { position: relative; flex: 0 0 360px; display: flex; flex-direction: column; gap: 16px; }
.saola-home__panel { position: relative; flex: none; width: 100%; box-sizing: border-box;
  padding: 28px 24px; background: rgba(255,255,255,0.95); border-radius: 18px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.3); }
.saola-home__panel a:hover { border-color: #0ea5a3 !important; }
.saola-home__qr { width: 100%; box-sizing: border-box; display: grid; grid-template-columns: 1fr 1fr; gap: 16px; padding: 16px 24px;
  background: rgba(255,255,255,0.95); border-radius: 18px; box-shadow: 0 10px 40px rgba(0,0,0,0.3); }
.saola-home__qr div { text-align: center; min-width: 0; }
.saola-home__qr img { display: block; width: 100%; max-width: 132px; aspect-ratio: 1 / 1; height: auto; margin: 0 auto; border-radius: 8px; border: 1px solid #e2e8f0; }
.saola-home__qr span { display: block; margin-top: 8px; font-size: 13px; font-weight: 700; color: #0f172a; }
@media (max-width: 900px) {
  .saola-home { flex-direction: column; justify-content: flex-start; padding: 16px; gap: 16px; }
  .saola-home__img { max-width: 100%; max-height: none; width: 100%; height: auto; }
  .saola-home__side { flex: none; width: 100%; max-width: 520px; }
}
`;

const Home = () => (
  <div className="saola-home">
    <style>{css}</style>
    <div className="saola-home__blur" />
    <img className="saola-home__img" src={BG} alt="Saola — Kỳ lân của núi rừng Việt Nam" />
    <div className="saola-home__side">
    <div className="saola-home__qr">
      <div><img src="/qr_android.jpg" alt="QR tải ứng dụng Android" /><span>📱 Tải app Android</span></div>
      <div><img src="/qr_web.jpg" alt="QR truy cập web" /><span>🌐 Truy cập web</span></div>
    </div>
    <div className="saola-home__panel">
      <h1 style={{ fontSize: 24, fontWeight: 800, margin: "0 0 6px" }}>Saola Information Technology</h1>
      <p style={{ color: "#64748b", margin: "0 0 20px" }}>Chọn ứng dụng bạn muốn dùng:</p>
      <div style={{ display: "grid", gap: 12 }}>
        <Link to="/happyschool" style={cardStyle}>
          <div style={{ fontSize: 32 }}>🏫</div>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700 }}>HappySchool</div>
            <div style={{ color: "#64748b", fontSize: 14, marginTop: 2 }}>Quản lý trường học</div>
          </div>
        </Link>
        <Link to="/quiz3" style={cardStyle}>
          <div style={{ fontSize: 32 }}>📝</div>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700 }}>Quiz3</div>
            <div style={{ color: "#64748b", fontSize: 14, marginTop: 2 }}>Luyện thi trắc nghiệm</div>
          </div>
        </Link>
      </div>
    </div>
    </div>
  </div>
);

export default Home;
